<app-loader [isLoading]="isLoading"></app-loader>
<div *ngIf="!isLoading">
  <div class="pt-4">
    <div class="container-fluid age-section mb-1 pt-4">
      <!-- Header -->
<div class="page-header">
  <div class="header-top">
    <h6>{{ formatCategoryName(mainCategory) }}</h6>
    <button mat-stroked-button color="primary" (click)="openFilter()">
      Filter
      <mat-icon>filter_alt</mat-icon>
    </button>
  </div>
  <p>{{ getCategoryInfo(mainCategory).description }}</p>
</div>      
<div class="category-scroll" *ngIf="showAllChip">
        <mat-chip-listbox>
          <mat-chip-option *ngFor="let chip of chipsList" [selected]="selectedCategory===chip.category"
            (click)="selectCategory(chip.category)">
            <img *ngIf="chip.image; else defaultIcon" [src]="chip.image" alt="{{ chip.category }}">
            <ng-template #defaultIcon>
              <div class="all-category">
                <mat-icon>grid_view</mat-icon>
              </div>
            </ng-template>
            <div class="chip-name">{{ formatCategory(chip.category) | titlecase }}</div>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>

      <div class="subcategory-scroll" *ngIf="showAllChip && subCategoryChips.length">
        <mat-chip-listbox>
          <mat-chip-option *ngFor="let chip of subCategoryChips" [selected]="selectedSubCategory===chip.subCategory"
            (click)="selectSubCategory(chip.subCategory)">
            <div class="chip-name">{{ formatCategory(chip.subCategory) | titlecase }}</div>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </div>

    <div class="product-grid-container">
      <div *ngFor="let searchData of searchItem" class="product-card">
        <img #productImage class="product-image" [src]="imageBaseUrl + searchData?.image"
          (click)="imgClick(searchData)" />
        <button type="button" class="search-share-button" [attr.aria-label]="'Share ' + searchData?.product_name"
          title="Share product" (click)="shareProduct(searchData, $event)">
          <mat-icon aria-hidden="true">share</mat-icon>
        </button>

        <!-- Product Details -->
        <div class="product-details mb-1" (click)="imgClick(searchData)">
          <div class="product-name">{{ searchData?.product_name }}</div>
          <div class="product-mrp">MRP: ₹{{ searchData?.mrp }}</div>
          <div class="product-price">Price: ₹{{ searchData?.price }}</div>
          <div class="search-rating" *ngIf="searchData?.total_reviews > 0"
            [attr.aria-label]="searchData.avg_rating + ' out of 5 from ' + searchData.total_reviews + ' reviews'">
            <span class="search-rating-value">{{ searchData.avg_rating | number:'1.1-1' }}</span>
            <!-- <span class="search-rating-count">({{ searchData.total_reviews }})</span> -->
            <span class="search-rating-stars" aria-hidden="true">
              <mat-icon *ngFor="let star of ratingStars">{{ getRatingIcon(searchData.avg_rating, star) }}</mat-icon>
            </span>
          </div>
          <div class="search-rating-empty" *ngIf="!searchData?.total_reviews">Be the first to rate</div>
        </div>

        <!-- Quantity Buttons -->
        <div class="quantity-btn-align" *ngIf="searchData.quantity > 0">
          <nav aria-label="quantity-navigation">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" (click)="$event.stopPropagation();decrement(searchData)">−</a>
              </li>
              <li class="page-item item-font">
                <a class="page-link qunt-back">{{ searchData.quantity }}</a>
              </li>
              <li class="page-item">
                <a class="page-link" [class.disabled]="searchData.quantity >= MAX_QTY"
                  (click)="$event.stopPropagation();flyToCartFromEvent($event);increment(searchData)">+</a>
              </li>
            </ul>
          </nav>
        </div>

        <!-- ADD TO CART BUTTON -->
        <button class="btn btn-warning btn-md btn-align-buy" *ngIf="searchData.quantity == 0"
          (click)="addCartQuntity($event,searchData);">
          ADD TO CART
        </button>

      </div>
    </div>

  </div>
</div>